import React, { useContext, useState, useEffect, useRef, useMemo, useCallback } from "react";
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import { DatabaseContext } from "../../../redux/DatabaseStore";
import '../../../assets/css/style.css';
import '../../../assets/css/iconsmenu.css'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, PrintIcon, SearchIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, CalendarIcon,EditRowIcon} from "../../svg/svgIcons";
import { deleteRequest, getRequest, postRequest, tabulatorGet } from '../../../api/ApiController';
import {useReactToPrint} from "react-to-print";
import EightDreport from "../../print/EightDreport";
import { InfinitySpin } from  'react-loader-spinner';
import { DateTime } from "luxon";
import AuthContext from "../../../components/AuthContext";
import moment from "moment";
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import UtilContext from "../../../components/UtilContext";
import IntersectionObserverWrapper from "../../../components/toolbar/IntersectionObserverWrap";
import { OverflowMenuProvider } from "../../../components/toolbar/OverflowMenu";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { LocaleContext } from "../../../components/LocaleContext";
import { defaultProductLogoSrc } from '../../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../../utils/printChrome';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../../utils/tabulatorScroll';
import { cleanSorters, parseSorters, parseMaskFilters, extractSafePaginationParams, createDedupedAjaxRequest, rowPassesErrorRecordHeaderFilters, refreshProgressiveFromStart } from '../../../utils/tabulatorProgressiveLoading';
import { getDateFormat, getDateTimeFormat } from '../../../utils/dateUtils';
import { getCurrency } from '../../../utils/moduleSettings';
import { formatCurrency } from '../../../utils/currencyUtils';
import { resetTabulatorMask } from '../../../utils/tabulatorResetMask';
const DEFAULT_COLUMNS_VISIBLE_OTK_STATISTICS = { specific_id: true, article_number: true, article_name: true, order_number: true, 'customer.name': true, offender_id: true, repair_costs: true, total_amount: true, defective_pieces: true, 'group.name': true, ack_error: true, claim_counterparty_number: true, 'error_type.name': true, 'contractor.name': true, contractor_note: true, 'record_processor.name': true, problem_description: true, main_reason: true, immediate_measure: true, long_term_measure: true, 'prevention.name': true, 'auditor.name': true, 'auditor_note': true, state: true, created_at: true };

export default function OTKStatistics({
  preview = null,
  timePeriod = null,
  date = null,
  drilldownRecords = null,
  ajaxURL = '/api/error_records/paged',
  listPageKey = 'ZoznamInt',
  presetCustomerIds = null,
}) {

  const [state,dispatch] = useContext(DatabaseContext);
  const {user} = useContext(AuthContext);
  const {locale,t} = useContext(LocaleContext);
  const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter, openChosenNotificationPreferences} = useContext(UtilContext);

  const usePaged = drilldownRecords == null;
  const tableData = usePaged ? undefined : drilldownRecords;

  const pageSizePc = useMemo(() => {
    const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
    const n = parseInt(v, 10);
    return (Number.isFinite(n) && n > 0) ? n : 50;
  }, [state.module_settings]);

  const [stepBackIcon,setStepBackIcon] = useState(true);
  const [insertIcon,setInsertIcon] = useState(!user.permissions?.includes("add otk-statistics"));
  const [editIcon,setEditIcon] = useState(true);
  const [deleteIcon,setDeleteIcon] = useState(true);
  const [favoriteIcon,setFavoriteIcon] = useState(false);
  const [copyIcon,setCopyIcon] = useState(true);
  const [searchIconColor,setSearchIconColor] = useState("");

  const [visibleSearch,setVisibleSearch] = useState(false);
  const [searchValue,setSearchValue] = useState('');
  const [printVisible,setPrintVisible] = useState(false);
  const [printValue,setPrintValue] = useState("Zoznam");
  const [visibleCalendar,setVisibleCalendar] = useState(false);
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("");

  const [markUnmark, setMarkUnmarked] = useState(true);

  const [columnsVisible, setColumnsVisible] = useState({specific_id: true,article_number: true,article_name:true,order_number:true,'customer.name':true,
  offender_id:true,repair_costs:true,total_amount:true,defective_pieces:true,'group.name':true,ack_error:true,claim_counterparty_number:true,
  'error_type.name':true,'contractor.name':true,contractor_note:true, 'record_processor.name':true,problem_description:true,
  main_reason:true,immediate_measure:true,long_term_measure:true,'prevention.name':true,'auditor.name':true,'auditor_note':true,state:true,created_at:true
  });
  const [maskVisible, setMaskVisible] = useState(false);
const [editErrorRecord, setEditErrorRecord] = useState([]);

  const [expandedKeys, setExpandedKeys] = useState({});

  const ref = useRef(null);
  const elementRef = useRef(null);
  const componentRef = useRef(null);
  const overlayRef = useRef(null);
  const inFlightRef = useRef({ sig: null, promise: null });
  const completedCacheRef = useRef(new Map());
  const tableBuiltRef = useRef(false);
  const savedHScrollRef = useRef({ left: 0, pending: false });
  const pendingRowIdsRef = useRef(new Set());
  const needsRedrawRef = useRef(false);
  const rafRedrawRef = useRef(null);
  const tableContainerRef = useRef(null);
  const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
  const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingData')), [getTable]);
  const isTableVisible = useCallback(() => {
    const table = getTable();
    if (!table) return false;
    const el = table.getElement?.() ?? table.element ?? table.rowManager?.element?.parentElement;
    return !!(el && el.offsetParent != null && el.clientHeight > 0);
  }, [getTable]);
  const scheduleRedraw = useCallback(() => {
    if (rafRedrawRef.current != null) return;
    rafRedrawRef.current = requestAnimationFrame(() => {
      const table = getTable();
      rafRedrawRef.current = null;
      if (!table) return;
      const ids = Array.from(pendingRowIdsRef.current);
      pendingRowIdsRef.current.clear();
      needsRedrawRef.current = false;
      const headerFilters = table.getHeaderFilters?.() ?? [];
      ids.forEach((id) => {
        const row = table.getRow?.(id);
        if (!row) return;
        const data = row.getData?.();
        if (!data) return;
        if (!rowPassesErrorRecordHeaderFilters(data, headerFilters)) {
          row.delete?.();
          return;
        }
        row.reformat?.();
      });
    });
  }, [getTable]);
  const captureHScroll = useCallback(() => {
    const table = getTable();
    if (!table) return;
    const holder = table.rowManager?.element;
    if (!holder) return;
    savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
  }, [getTable]);
  const restoreHScroll = useCallback(() => {
    if (!savedHScrollRef.current.pending) return;
    const table = getTable();
    if (!table) return;
    const holder = table.rowManager?.element;
    const header = table.columnManager?.contentsElement;
    if (!holder) return;
    const left = savedHScrollRef.current.left;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        holder.scrollLeft = left;
        if (header) header.scrollLeft = left;
        savedHScrollRef.current.pending = false;
      });
    });
  }, [getTable]);
  const handlePrint = useReactToPrint({
    onBeforeGetContent: () => {componentRef.current.style.display = "block";},
    onAfterPrint: () => {componentRef.current.style.display = "none";},
    content: () => componentRef.current,
  });
  
  
  function matchAny(data, filterParams) {
    var match = false;
    const regex = RegExp(filterParams.value, 'i');

    for (var key in data) {
        if (regex.test(data[key]) === true) {
            match = true;
        }
    }
    return match;
  }

  function dateRange(data, filterParams) {
    console.log(data.created_at,filterParams);
    return moment(filterParams.fromDate).isSameOrBefore(data.created_at.substring(0,10)) && moment(filterParams.toDate).isSameOrAfter(data.created_at.substring(0,10));
  }

  function searchTable(){
    const t = getTable();
    if (t) t.setFilter(matchAny, { value: searchValue});
    setSearchIconColor("active");
    if (searchValue === " ") getTable()?.clearFilter?.();
    setVisibleSearch(false);
  }

  function searchByDate(){
    if (usePaged) {
      refreshFromStart();
      setSearchIconColor("active");
      setVisibleCalendar(false);
    } else {
      const t = getTable();
      if (t) t.setFilter(dateRange, { fromDate, toDate });
      setSearchIconColor("active");
      setVisibleCalendar(false);
    }
  }

  const accept = () => {
    const rows_to_delete = getTable()?.getSelectedData?.() ?? [];
    rows_to_delete.forEach(element => {
      deleteRequest(`/api/error_records/${element.id}`)
      .then((response) => {
        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
        if (usePaged) {
          refreshFromStart();
        } else {
          getRequest("/api/error_records").then((response) => {
            dispatch({type:'load_error_records',newErrorRecords:response.data});
          });
        }
      }).catch((reason) => {
          alert(reason);
          toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
      })
    });
  }

  const reject = () => {
    toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.RequestCancelled'), life: 3000 });
  }

  const confirm = () => {
      confirmDialog({
          message: t('OTKStatistics.Confirm.DeleteRecordsMessage'),
          header: t('ServiceTask.ConfirmDeleteTitle'),
          icon: 'pi pi-info-circle',
          rejectClassName: 'p-button-danger',
          acceptLabel: t('Common.No'),
          rejectLabel: t('Common.Yes'),
          defaultFocus: 'accept',
          reject: accept,
          accept: reject
      });
  };


  const rowClick = (e, row) => {
    console.log(e, row);
  };

 const onSelectRow = (data, rows) => {
  setEditErrorRecord(data);
  setEditIcon(true);
  setCopyIcon(true);
  setDeleteIcon(true);
  if(data.length !== 0){
    if(user.permissions?.includes("add otk-statistics") || data[0].contractor_id==user.employee.id)setCopyIcon(false);
    if(user.permissions?.includes("edit otk-statistics") || data[0].contractor_id==user.employee.id)setEditIcon(false);
    if(user.permissions?.includes("delete otk-statistics"))setDeleteIcon(false);
  }
};

function offenderHeaderFilter(headerValue, rowValue, rowData, filterParams){
  if(rowData?.offender?.employee){
    return rowData?.offender?.employee?.name.toUpperCase().includes(headerValue.toUpperCase());
  }
  else if(rowData?.offender?.supplier){
    return rowData?.offender?.supplier?.name.toUpperCase().includes(headerValue.toUpperCase());
  }
  else return rowData?.offender?.customer?.name.toUpperCase().includes(headerValue.toUpperCase());
}

function OffenderFormatter(props) {
  const rowData = props.cell.getRow().getData();
  if(rowData.offender==null)return "";
  if(rowData.offender.type=="customer"){
    return (state.companies || []).find(c => c.customer_offender_id === rowData.offender_id)?.name;
  }
  else if(rowData.offender.type=="supplier"){
    return (state.companies || []).find(c => c.supplier_offender_id === rowData.offender_id)?.name;
  }
  else{
    return (state.employees || []).find(e => e.offender_id === rowData.offender_id)?.name;
  }
}

function onEditRow(error_record){
  if(error_record?.type== 'Interná chyba'){
    dispatch({type:'create_new_tab',name: t('Otk.EditInternalErrorUpper'), translationKey: 'Otk.EditInternalErrorUpper', legacyLabel: t('Otk.EditInternalErrorUpper'),page:'InternaChyba',props:{error_record: error_record,er_type:'edit'},mask:'qlty003'})
  }
  else if(error_record?.type== 'Externá chyba'){
    dispatch({type:'create_new_tab',name: t('Otk.EditExternalErrorUpper'), translationKey: 'Otk.EditExternalErrorUpper', legacyLabel: t('Otk.EditExternalErrorUpper'),page:'ExternaChyba',props:{error_record: error_record,er_type:'edit'},mask:'qlty005'})
  }
  else if(error_record?.type== 'Reklamácia'){
    dispatch({type:'create_new_tab',name: t('Otk.EditComplaintUpper2'), translationKey: 'Otk.EditComplaintUpper2', legacyLabel: t('Otk.EditComplaintUpper2'),page:'Reklamacia',props:{error_record: error_record,er_type:'edit'},mask:'qlty007'})
  }
};

function EditRowFormatter(props) {
  const rowData = props.cell.getRow().getData();
  return <div className='flex justify-center items-start w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
}

  const [draggingItem,setDraggingItem] = useState(null); 
  const getColumns = (t, locale, currency, dateFormat, dateTimeFormat) =>[
    { hozAlign:"center", field: 'editor', width: 44, headerSort:false, formatter: reactFormatter(<EditRowFormatter/>), resizable:false },
    { title: t("Poradove cislo"), field: 'specific_id', headerFilter:"input", width: 200, minWidth: 200 },
    { title: t('Artikel'), field: 'article_number', headerFilter:"input", width: 200, minWidth: 200 },
    { title: t('Nazov artikla'), field: 'article_name', headerFilter:"input", width: 200, minWidth: 200 },
    { title: t('Zakazka'), field: 'order_number', headerFilter:"input", width: 200, minWidth: 200 },
    { title: t('Zakaznik'), field: 'customer.name', headerFilter:"input", width: 200, minWidth: 200 },
    { title: t('Vinnik'), field: 'offender_id', headerFilter:"input", headerFilterFunc: offenderHeaderFilter, width: 200, minWidth: 200, formatter: reactFormatter(<OffenderFormatter />) },
    { title: t('Naklady'), field: 'repair_costs', headerFilter:"input", width: 200, minWidth: 200, formatter: (cell) => formatCurrency(cell.getValue(), currency) },
    { title: t('Mnozstvo'), field: 'total_amount', headerFilter:"input", width: 200, minWidth: 200 },
    { title: t('Pocet chybnych'), field: 'defective_pieces', headerFilter:"input", width: 200, minWidth: 200 },

    // Multijazyčné stĺpce
    {
      title: t('Skupina'),
      field: 'group.name',
      formatter: (cell) => {
        const data = cell.getValue();
        return data?.[locale] || data?.sk || "";
      },
      headerFilter: "input",
      headerFilterFunc: (headerValue, rowValue, rowData) => {
        const value = rowData.group?.name || {};
        return (value[locale] || value.sk || "").toLowerCase().includes(headerValue.toLowerCase());
      },
      sorter: (a, b, aRow, bRow) => {
        const valA = aRow.getCell('group.name').getValue() || {};
        const valB = bRow.getCell('group.name').getValue() || {};
        return (valA[locale] || valA.sk || "").localeCompare(valB[locale] || valB.sk || "");
      },
      width: 200, minWidth: 200
    },
    {
      title: t('Chyba'),
      field: 'ack_error',
      formatter: (cell) => t(cell.getValue() || ""),
      headerFilter: "list",
      headerFilterParams: {
          values: {
            "": t("Všetko"),    // prázdna hodnota = bez filtra
            Uznaná: t("Uznaná"),
            Neuznaná: t("Neuznaná"),
          },
        },
      headerFilterFunc: "=",
      sorter: (a, b, aRow, bRow) => {
        const valA = aRow.getCell('ack_error').getValue() || {};
        const valB = bRow.getCell('ack_error').getValue() || {};
        return (valA[locale] || valA.sk || "").localeCompare(valB[locale] || valB.sk || "");
      },
      width: 200, minWidth: 200
    },
    { title: t('Cislo reklamacie'), field: 'claim_counterparty_number', headerFilter:"input", width: 250, minWidth: 250 },
    {
      title: t('Druh chyby'),
      field: 'error_type.name',
      formatter: (cell) => {
        const data = cell.getValue();
        return data?.[locale] || data?.sk || "";
      },
      headerFilter: "input",
      headerFilterFunc: (headerValue, rowValue, rowData) => {
        const value = rowData.error_type?.name || {};
        return (value[locale] || value.sk || "").toLowerCase().includes(headerValue.toLowerCase());
      },
      sorter: (a, b, aRow, bRow) => {
        const valA = aRow.getCell('error_type.name').getValue() || {};
        const valB = bRow.getCell('error_type.name').getValue() || {};
        return (valA[locale] || valA.sk || "").localeCompare(valB[locale] || valB.sk || "");
      },
      width: 200, minWidth: 200
    },
    { title: t('Zadávateľ'), field: 'contractor.name', headerFilter:"input", width: 200, minWidth: 200 },
    { title: t('Pozn. zadávateľa'), field: 'contractor_note', headerFilter:"input", width: 200, minWidth: 200 },
    { title: t('Spracovateľ'), field: 'record_processor.name', headerFilter:"input", width: 200, minWidth: 200 },
    { title: t('Popis problému'), field: 'problem_description', headerFilter:"input", width: 200, minWidth: 200 },
    { title: t('Hlavná príčina'), field: 'main_reason', headerFilter:"input", width: 200, minWidth: 200 },
    { title: t('Okamžité opatrenie'), field: 'immediate_measure', headerFilter:"input", width: 220, minWidth: 220 },
    { title: t('Dlhodobé opatrenie'), field: 'long_term_measure', headerFilter:"input", width: 220, minWidth: 220 },
    {
      title: t('Zabránenie skrz'),
      field: 'prevention.name',
      formatter: (cell) => {
        const data = cell.getValue();
        return data?.[locale] || data?.sk || "";
      },
      headerFilter: "input",
      headerFilterFunc: (headerValue, rowValue, rowData) => {
        const value = rowData.prevention?.name || {};
        return (value[locale] || value.sk || "").toLowerCase().includes(headerValue.toLowerCase());
      },
      sorter: (a, b, aRow, bRow) => {
        const valA = aRow.getCell('prevention.name').getValue() || {};
        const valB = bRow.getCell('prevention.name').getValue() || {};
        return (valA[locale] || valA.sk || "").localeCompare(valB[locale] || valB.sk || "");
      },
      width: 200, minWidth: 200
    },
    {
      title: t('Korenova pricina'),
      field: 'root_cause.name',
      formatter: (cell) => {
        const data = cell.getValue();
        return data?.[locale] || data?.sk || "";
      },
      headerFilter: "input",
      headerFilterFunc: (headerValue, rowValue) => {
        if (!rowValue) return false;
        const value = rowValue[locale] || rowValue.sk || "";
        return value.toLowerCase().includes(headerValue.toLowerCase());
      },
      sorter: (a, b, aRow, bRow) => {
        const valA = aRow.getCell('root_cause.name').getValue() || {};
        const valB = bRow.getCell('root_cause.name').getValue() || {};
        return (valA[locale] || valA.sk || "").localeCompare(valB[locale] || valB.sk || "");
      },
      width: 200, minWidth: 200
    },
    { title: t('Kontrolór'), field: 'auditor.name', headerFilter:"input", width: 200, minWidth: 200 },
    { title: t('Pozn. kontrolóra'), field: 'auditor_note', headerFilter:"input", width: 200, minWidth: 200 },
    { title: t('Stav'), field: 'state', headerFilter:"input", width: 200, minWidth: 200 },
    {
      title: t('Datum'),
      field: 'created_at',
      headerFilter: "input",
      headerFilterFunc: (headerValue, rowValue, rowData, filterParams) => {
        if (!headerValue) return true;
        if (!rowValue) return false;
        const dt = DateTime.fromISO(rowValue);
        if (!dt.isValid) return false;
        const needle = headerValue.toLowerCase().trim();
        const full = dt.toFormat(dateTimeFormat).toLowerCase();
        const dayMonth = dt.toFormat("dd.MM").toLowerCase();
        const monthYear = dt.toFormat("MM.yyyy").toLowerCase();
        const fullDate = dt.toFormat(dateFormat).toLowerCase();
        return full.includes(needle) || fullDate.includes(needle) || dayMonth.includes(needle) || monthYear.includes(needle);
      },
      width: 200, minWidth: 200,
      formatter: function (cell) {
        const value = cell.getValue();
        const dt = DateTime.fromISO(value);
        return dt.isValid ? dt.toFormat(dateTimeFormat) : "";
      },
    },
  ];

  const columns = useMemo(() => {
    const ms = state.module_settings || [];
    return getColumns(t, locale, getCurrency(ms), getDateFormat(ms), getDateTimeFormat(ms));
  }, [t, locale, state.module_settings]);

  useEffect(() => {
    const t = getTable();
    if (t) t.setColumns(columns);
  }, [columns, getTable]);

  const scrollToFirst = () => scrollToFirstUtil(getTable());
  const scrollUp = () => scrollUpUtil(getTable());
  const scrollDown = () => scrollDownUtil(getTable());
  const scrollToLast = () => scrollToLastUtil(getTable());

  const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
    const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
    if (extra.size == null) extra.size = pageSizePc;
    if (preview != null && preview !== '') extra.preview = preview;
    if (timePeriod != null && timePeriod !== '') extra.timePeriod = timePeriod;
    if (date != null) extra.date = typeof date === 'string' ? date : (Array.isArray(date) ? JSON.stringify(date) : date);
    if (fromDate) extra.fromDate = fromDate;
    if (toDate) extra.toDate = toDate;
    if (Array.isArray(presetCustomerIds) && presetCustomerIds.length > 0) {
      extra.customer_ids = presetCustomerIds.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0);
    }
    const t = getTable();
    const tableReadyForParams = tableBuiltRef.current;
    let hf = [];
    if (tableReadyForParams) hf = t?.getHeaderFilters?.() ?? [];
    if (tableReadyForParams && hf.length) {
      hf.forEach(f => {
        if (f?.field == null) return;
        const v = f.value;
        if (v === undefined || v === null) return;
        if (typeof v === 'object') return;
        const str = String(v).trim();
        if (str === '') return;
        extra[`filter_${f.field}`] = str;
      });
    } else if (!tableReadyForParams && state.user_mask_filters) {
      const maskRow = (state.user_mask_filters || []).find(m => m.page === listPageKey);
      if (maskRow) {
        parseMaskFilters(maskRow.filters).forEach(f => {
          if (!f?.field) return;
          const v = f.value;
          if (v === undefined || v === null || String(v).trim() === '') return;
          extra[`filter_${f.field}`] = v;
        });
      }
    }
    let sortersFromTable = [];
    if (tableReadyForParams) sortersFromTable = t?.getSorters?.() ?? [];
    const hasSorters = Array.isArray(sortersFromTable) && sortersFromTable.length > 0;
    if (hasSorters) {
      const clean = cleanSorters(sortersFromTable);
      if (clean.length > 0) extra.sorters = JSON.stringify(clean);
    } else if (!tableReadyForParams && state.user_mask_filters) {
      const maskRow = (state.user_mask_filters || []).find(m => m.page === listPageKey);
      if (maskRow?.sorters) {
        const parsed = parseSorters(maskRow.sorters);
        if (parsed.length > 0) extra.sorters = JSON.stringify(parsed.map(s => ({ field: s.field ?? s.column, dir: s.dir })));
      }
    }
    return extra;
  }, [getTable, state.user_mask_filters, preview, timePeriod, date, fromDate, toDate, pageSizePc, presetCustomerIds, listPageKey]);

  function confirmPrintDialog(){
    if (printValue === "Zoznam") {
      getTable()?.print?.(false, true);
    } else {
      handlePrint();
    }
  }

    function handleDragStart(e, item){ 
      setDraggingItem(item);
      e.dataTransfer.setData('text/plain', ''); 
    }; 

    function handleDragEnd(){ 
      setDraggingItem(null);
    }; 

    function handleDragOver(e){ 
        e.preventDefault(); 
    }; 

    function handleDrop(e, targetItem){ 
        if (!draggingItem) return; 

        const currentIndex = columns.indexOf(draggingItem); 
        const targetIndex = columns.indexOf(targetItem); 

        if (currentIndex !== -1 && targetIndex !== -1) {
          columns.splice(currentIndex, 1);
          columns.splice(targetIndex, 0, draggingItem);
        }
        getTable()?.setColumns?.(columns);
    }; 
  
  function setMask(item, value) {
    const columnVisible = { ...columnsVisible };
    columnVisible[item] = value;
    const t = getTable();
    for (const val in columnVisible) {
      if (columnVisible[val] === false) t?.hideColumn?.(val);
      else t?.showColumn?.(val);
    }
    setColumnsVisible(columnVisible);
  }

  const itemRenderer = (item, options) => (
    <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
        <span className={`${item.icon} text-primary`} />
        <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
        {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
    </a>
  );


  const handleClickOutside = (event) => {
    if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        setExpandedKeys({});
    }
  };

  useEffect(() => {
      document.addEventListener('click', handleClickOutside, true);
      return () => {
          document.removeEventListener('click', handleClickOutside, true);
      };
  }, []);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (!container) return;
    const ro = new ResizeObserver(() => {
      if (needsRedrawRef.current && isTableVisible()) scheduleRedraw();
    });
    ro.observe(container);
    return () => ro.disconnect();
  }, [isTableVisible, scheduleRedraw]);

  useEffect(() => {
    if (!usePaged) return;
    const handler = (e) => {
      const id = e.detail?.id;
      if (id == null) return;
      const table = getTable();
      if (!table) return;
      getRequest(`/api/error_records/${id}`)
        .then((res) => {
          const data = res?.data ?? res;
          if (!data?.id) return;
          const row = table.getRow?.(id);
          if (row) row.update(data);
          else table.addData?.([data]);
          pendingRowIdsRef.current.add(id);
          if (isTableVisible()) scheduleRedraw();
          else needsRedrawRef.current = true;
        })
        .catch(() => {});
    };
    window.addEventListener('error_record_saved', handler);
    return () => window.removeEventListener('error_record_saved', handler);
  }, [usePaged, getTable, isTableVisible, scheduleRedraw]);

  const resetMask = () => resetTabulatorMask({
    page: listPageKey,
    defaultColumnsVisible: DEFAULT_COLUMNS_VISIBLE_OTK_STATISTICS,
    ref, columns, setColumnsVisible,
  });

    const items = [
    {
      key: '0',
      label: t('Common.Actions'),
      icon: 'pi pi-sliders-v',
      template: itemRenderer,
      items: [
            {
              key: '0_1',
              label: t('Common.SetFilter'),
              icon: 'pi pi-filter',
              command: () => { setUserMaskFilter(listPageKey,"set_filters",null,getTable()?.getHeaderFilters?.() ?? [],null); if (usePaged) refreshFromStart() },
              template: itemRenderer,
          },
            {
              key: '0_2',
              label: t('Common.ClearFilter'),
              icon: 'pi pi-filter-slash',
              command: () => { setUserMaskFilter(listPageKey,"set_filters",null,[],null); getTable()?.clearHeaderFilter?.(); if (usePaged) refreshFromStart() },
              template: itemRenderer,
          },
          {
              key: '0_3',
              label: t('Common.SetSorting'),
              icon: 'pi pi-sort-alt',
              command: () => { setUserMaskFilter(listPageKey,"set_sorters",null,null,null, getTable()?.getSorters?.() ?? []); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); if (usePaged) refreshFromStart() },
              template: itemRenderer,
          },
          {
              key: '0_4',
              label: t('Common.ClearSorting'),
              icon: 'pi pi-sort-alt-slash',
              command: () => { setUserMaskFilter(listPageKey,"set_sorters",null,null,null,[]); getTable()?.setSort?.([]); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); if (usePaged) refreshFromStart() },
              template: itemRenderer,
          },
          {
              key: '0_5',
              label: t('Common.SetMask'),
              icon: 'pi pi-server',
              command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
              template: itemRenderer,
          },
          {
              key: '0_5b',
              label: t('Common.ResetUserMask'),
              icon: 'pi pi-refresh',
              command: () => {resetMask();OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
              template: itemRenderer,
          },
          {
            key: '0_6',
            label: t('Common.Notifications'),
            icon: 'pi pi-envelope',
            command: () => {openChosenNotificationPreferences('OTKStatistics');OverflowMenuProvider.setVisible(null);},
            template: itemRenderer,
        },
      ]
    }
  ];function previewFilter(data, filterParams){
    //data - the data for the row being filtered
    //filterParams - params object passed to the filter
    if(filterParams.time_period== 'Za deň'){
      return new Date(data.created_at).toDateString() == new Date(filterParams.date).toDateString();
      //return new Date(data.created_at) > new Date(new Date().setDate(new Date().getDate() - 365));
    }
    else if(filterParams.time_period=="Za mesiac"){
      return new Date(data.created_at).getFullYear() == new Date(filterParams.date).getFullYear() && new Date(data.created_at).getMonth() == new Date(filterParams.date).getMonth();
    }
    else if(filterParams.time_period=="Za rok"){
      return new Date(data.created_at).getYear() == new Date(filterParams.date).getYear();
    }
    else if(filterParams.time_period=="Vlastné"){
      var end_date = new Date(filterParams.date[1]);
      end_date.setDate(end_date.getDate() + 1);
      return new Date(data.created_at).valueOf() >= new Date(filterParams.date[0]).valueOf() && new Date(data.created_at).valueOf() <= new Date(end_date).valueOf();
    }
    else if(filterParams.time_period== 'Všetky'){
       return true;
    }
    return false;
}

  function changeMarkings(value) {
    const t = getTable();
    const columnVisible = { ...columnsVisible };
    for (const val in columnVisible) {
      if (val !== "id" && val !== "editor") {
        columnVisible[val] = !!value;
        if (value) t?.showColumn?.(val);
        else t?.hideColumn?.(val);
      }
    }
    setColumnsVisible(columnVisible);
  }

  const exportToExcel = () => {
        const excel_type = {};
        excel_type[t('Otk.InternalError')] = "ICH";
        excel_type[t('Otk.ExternalError')] = "ECH";
        excel_type[t('Otk.Complaint')] = "REK";
        const dateFmt = getDateTimeFormat(state.module_settings || []);
        let error_records = (getTable()?.getData?.("active") ?? []).map((x) => {
        let id = x.specific_id;
        let type = excel_type[x.type];
        let artikel = x.article_number;
        let nazov_artikla = x.article_name;
        let zakazka = x.order_number;
        let zakaznik = x.customer?.name;
        let zakaznik_id = x.customer?.defined_id;
        let zakaznik_popis = x.customer?.description;
        let vinnik_oddelenie="";
        if(x.offender?.type)vinnik_oddelenie = x.offender.type=="customer" ? "Zakaznik" : (x.offender.type=="supplier" ? "Dodavatel" : x.offender.employee.department.name);
        let vinnik_id_oddelenie = "";
        if(x.offender?.type)vinnik_id_oddelenie = x.offender.type=="customer" ? "110999" : (x.offender.type=="supplier" ? "110888" : x.offender.employee.department.defined_id);
        let vinnik = "";
        if(x.offender?.type)vinnik = x.offender.type=="customer" ? x.offender.customer.name : (x.offender.type=="supplier" ? x.offender.supplier.name : x.offender.employee.name);
        let vinnik_id = "";
        if(x.offender?.type)vinnik_id = x.offender.type=="customer" ? x.offender.customer.defined_id : (x.offender.type=="supplier" ? x.offender.supplier.defined_id : x.offender.employee.defined_id);
        let vinnik_popis = "";
        let naklady_oprava = parseInt(x.repair_costs);
        let celkove_mnozstvo = x.total_amount;
        let pocet_chybnych = x.defective_pieces;
        let skupina = x.group?.name?.["sk"];
        let uznana_neuznana = x.ack_error;
        let cislo_rek_protistrany = x.claim_counterparty_number;
        let druh_chyby = x.error_type?.name?.["sk"];
        let poznamka_zadavatela = x.contractor_note;
        let spracovatel_oddelenie = x.record_processor?.department?.name;
        let spracovatel_meno = x.record_processor?.name;
        let popis_problemu = x.problem_description;
        let hlavna_pricina = x.main_reason;
        let okamzite_opatrenie = x.immediate_measure;
        let dlhodobe_opatrenie = x.long_term_measure;
        let zabranenie = x.prevention?.name?.["sk"];
        let korenova_pricina = x?.root_cause?.name?.["sk"];
        let kontrola_oddelenie = x.auditor?.department?.name;
        let kontrola_meno = x.auditor?.name;
        let poznamka_kontrola = x.auditor_note;
        let stav = x.state;
        let datum_zalozenia = DateTime.fromISO(x.created_at).isValid ? DateTime.fromISO(x.created_at).toFormat(dateFmt) : "";
        let rok =  parseInt(DateTime.fromISO(x.created_at).toFormat("yyyy"));
        let mesiac = parseInt(DateTime.fromISO(x.created_at).toFormat("M"));
        return {
            id,type,artikel,nazov_artikla,zakazka,zakaznik,zakaznik_id,zakaznik_popis,vinnik_oddelenie,vinnik_id_oddelenie,vinnik,vinnik_id,vinnik_popis,
            naklady_oprava,celkove_mnozstvo,pocet_chybnych,skupina,uznana_neuznana,cislo_rek_protistrany,druh_chyby,poznamka_zadavatela,
            spracovatel_oddelenie,spracovatel_meno,popis_problemu,hlavna_pricina,okamzite_opatrenie,dlhodobe_opatrenie,zabranenie,korenova_pricina,
            kontrola_oddelenie,kontrola_meno,poznamka_kontrola,stav,datum_zalozenia,rok,mesiac

        };
        }).sort((a, b) => (parseInt(a.specific_id) > parseInt(b.specific_id)) ? -1 : 1);
        const worksheet = XLSX.utils.json_to_sheet(error_records);
        /*console.log(error_records.length);
        var fmt_currency =  '#,##0.00\ "€";[Red]\-#,##0.00\ "€"';
        var fmt_float = '0.00';
        var fmt_int = '0';
        for (let i = 2; i < error_records.length+2; i++) {
          worksheet['N'+i].z = fmt_currency;
          worksheet['O'+i].z = fmt_float;
          worksheet['P'+i].z = fmt_float;
          worksheet['AH'+i].z = fmt_int;
          worksheet['AI'+i].z = fmt_int;
        }
        delete worksheet["N2"].w;
        worksheet["N2"].z = fmt_currency;
        console.log(XLSX.utils.format_cell(worksheet["N2"]));*/
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Chyby");
        
        
        // Buffer to store the generated Excel file
        const excelBuffer = XLSX.writeFile(workbook, "otk_statistika.xlsx",{bookSST:true});//{ bookType: 'xlsx', type: 'array' });
        //const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });

        //saveAs(blob, "otk_statistika.xlsx");
    };

    return (
        <>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="search"><button onClick={searchIconColor!=="active"? () => {setVisibleSearch(true);}:() => {setSearchIconColor("");setSearchValue("");getTable()?.clearFilter?.();}}>{searchIconColor === "" ?  <MdSearch fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.Search')}/> : <MdSearchOff fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.CancelSearch')}/>}</button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="export"><button onClick={() => exportToExcel()}><ExportIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center align-center ' data-targetid="calendar"><button onClick={() => setVisibleCalendar(true)}><CalendarIcon/></button></div>
          {usePaged && (
            <>
              <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button onClick={() => { captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
              <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
              <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
              <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
              <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
              <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
              <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
            </>
          )}
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('Otk.StatisticsOutput'),"OTKStatistics")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="fast"><button onClick={() => setFastView("OTKStatistics",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '  data-targetid="vert"><VerticalLineIcon/></div>
          <div className="card flex justify-content-center z-[100] " data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
    </IntersectionObserverWrapper>
      </div>
<div className='px-1 bg-white rounded-md shadow-md'>
<div className="flex flex-col overflow-x-auto no-scrollbar min-h-[calc(100vh-177px)]">
  <div className="overflow-hidden" ref={tableContainerRef}>
    <div className="inline-block w-full py-2">
      <div ref={elementRef}>
        <ReactTabulator
        data={tableData}
        className='h-[calc(100vh_-_193px)]'
        onRef={(r) => (ref.current = r?.current)}
        columns={columns}
        events={{
          rowClick: rowClick,
          rowSelectionChanged: onSelectRow,
          tableBuilt: () => {
            tableBuiltRef.current = true;
            const t = getTable();
            let mask = (state.user_mask_filters || []).filter(m => m.page === listPageKey);
            const safeParse = (v, fallback) => {
              if (v === null || v === undefined) return fallback;
              if (typeof v === "string") { try { return JSON.parse(v); } catch { return fallback; } }
              return v;
            };
            if (mask.length > 0 && t) {
              const attributes  = safeParse(mask[0].attributes, []);
              const filters     = safeParse(mask[0].filters, []);
              const sorters     = safeParse(mask[0].sorters, []);
              const json_columns = safeParse(mask[0].columns, {});
              if (Array.isArray(attributes) && attributes.length > 1) t.setColumnLayout(attributes);
              if (Array.isArray(filters)) filters.forEach(f => t.setHeaderFilterValue(f.field, f.value));
              if (Array.isArray(sorters) && sorters.length > 0) t.setSort(sorters);
              if (json_columns && typeof json_columns === "object") {
                setColumnsVisible(json_columns);
                for (const column in json_columns) {
                  if (json_columns[column] === false) t.hideColumn(column);
                  else t.showColumn(column);
                }
              }
              if (usePaged) refreshFromStart();
            }
          },
          columnMoved: () => {
            setUserMaskFilter(listPageKey,"column_move",null,null,getTable()?.getColumnLayout?.());
          },
          columnResized: () => {
            setUserMaskFilter(listPageKey,"column_move",null,null,getTable()?.getColumnLayout?.());
          }
        }}
        options={{
          layout: "fitColumns",
          renderHorizontal: "virtual",
          movableColumns: true,
          printAsHtml: true,
          printHeader: () => buildCanonicalPrintHeaderHtml({
            branding: state?.branding,
            productFallbackSrc: defaultProductLogoSrc,
            companySettingsPrint: state?.company_settings_print,
            moduleSettings: state?.module_settings,
            title: t('Print.Title.OtkInternalErrors'),
            printDateLabel: t('Print.DateLabel'),
          }),
          printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
          printRowRange: "active",
          ...(usePaged ? {
            ajaxURL: ajaxURL,
            ajaxParams: () => ({}),
            ajaxRequestFunc: createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
            dataLoader: true,
            dataLoaderLoading: t('Common.LoadingData'),
            dataLoaderError: t('Common.LoadFailed'),
            progressiveLoad: 'scroll',
            progressiveLoadScrollMargin: 80,
            paginationSize: pageSizePc,
            filterMode: 'remote',
            sortMode: 'remote',
            pagination: false,
            ajaxRequesting: () => {
              captureHScroll();
              const table = getTable();
              if (table?.initialized) table.alert?.(t('Common.LoadingData'));
              return true;
            },
            ajaxResponse: (url, params, response) => {
              getTable()?.clearAlert?.();
              restoreHScroll();
              return response;
            },
            ajaxError: () => {
              getTable()?.clearAlert?.();
            },
            initialSort: [{ column: 'specific_id', dir: 'desc' }],
          } : {}),
        }}/> 
      </div> 
    </div> 
  </div> 
</div>
            <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
              <div className="flex flex-columns">
                
                <input
                    value={searchValue} onChange={e => setSearchValue(e.target.value)}
                    type="text"
                    className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                />
                <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
              </div>
            </Dialog>
            <Dialog header={t('Common.SearchInListByDate')} visible={visibleCalendar} style={{ width: '40vw' }} onHide={() => setVisibleCalendar(false)}>
              <div className="flex flex-columns justify-between">
                <label>
                  Od:
                <input
                    value={fromDate} onChange={e => setFromDate(e.target.value)}
                    type="date"
                    className="block w-full px-1 py-1 mr-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                /> 
                </label>
                <label>
                  Do:
                <input
                    value={toDate} onChange={e => setToDate(e.target.value)}
                    type="date"
                    className="block w-full px-1 py-1 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                />
                </label>
                <button onClick={() => searchByDate()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
              </div>
            </Dialog>
            <Dialog header={t('Common.PrintAs')} visible={printVisible} style={{ width: '40vw' }} onHide={() => setPrintVisible(false)}>
        <div className="flex flex-columns">
          <select 
          value={printValue} onChange={e => setPrintValue(e.target.value)}
          className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
            <option value="8D">8D report</option>
            <option value="Zoznam">Zoznam</option>                      
          </select>
          <button onClick={() => confirmPrintDialog()} className='w-20 ml-8 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.PrintUpper')}</button>
        </div>
      </Dialog>
      <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<2) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                        draggable="true"
                        onDragStart={(e) =>  
                            handleDragStart(e, item)} 
                        onDragEnd={() => handleDragEnd()} 
                        onDragOver={(e) => handleDragOver(e)} 
                        onDrop={(e) => handleDrop(e, item)} 
                    > 

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })}
                 <button onClick={() => {setUserMaskFilter(listPageKey,"set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
      {/* button to trigger printing of target component */}
        {/* component to be printed */}
        <div ref={componentRef} style={{display:'none'}}>
          {editErrorRecord.map((error_record) => (
                             <EightDreport key={error_record.id} error_record={error_record}/>
          ))}
        </div>
        
</div> 
</>
    );
}
